<template>
  <!-- 按钮筛选器 -->
  <div class="filter-widget">
      <span @click="onFilter(item)" class="filter-btn" :class="activeFilter==item.value ? 'active': ''" v-for="(item, index) in filterList" :key="index">{{item.text}}</span>
  </div>
</template>
<script>
export default {
  props: {
    filterList: Array
  },
  data() {
    return {
      activeFilter: ''
    }
  },
  created() {

  },
  methods: {
    onFilter: function (details) {
      this.activeFilter = details.value
      this.$emit('change', details.value)
    }
  }
}
</script>
<style scoped>
/* components/filterwidget/index.wxss */
.filter-widget .filter-btn {
    margin-top: var(--len5);
    display: inline-block;
    font-weight: normal;
    background-color: rgba(0, 0, 0, 0.1);
    border: 0.5px solid white;
    font-size: var(--len12);
    text-align: center;
    padding: 0 var(--len14);
    height: var(--len25);
    line-height: var(--len25);
    border-radius: var(--len25);
    margin-right: var(--len12);
}

.filter-widget .filter-btn:last-child {
    margin-right: 0;
}

.filter-widget .filter-btn.active {
    color: var(--primary-color);
    border: 0.5px solid var(--primary-color);
    background-color: rgba(255, 165, 0, 0.3);
}
</style>